var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vx-badge",class:_vm.classes},[(_vm.content)?[_vm._v(_vm._s(_vm.content))]:_vm._e(),_vm._t("default"),_c('span',{staticClass:"vx-badge__wrapper"},[_c('span',{staticClass:"vx-badge__badge",style:(_vm.styles)})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }